import Component from '../core/Component';

export default class FixedTopbar extends Component {
    constructor(element) {
        super(element);
    }

    prepare() {
        this.topbar = this.element;
        this.sticky = this.topbar.offsetTop;
        
        window.addEventListener('scroll',::this.handleScroll)
    }

    handleScroll() {
        if (window.pageYOffset >= this.sticky) {
            this.topbar.classList.add("is-fixed");
        } else {
            this.topbar.classList.remove("is-fixed");
        }
    }
}


// WEBPACK FOOTER //
// ./components/FixedTopbar.js